<template>
  <v-app>
    <v-main class="primary100">
      <v-row class="d-flex flex-row align-center justify-center fill-height">
        <v-col cols="12" md="4">
          <v-card class="rounded-lg pa-2">
            <v-container class="d-flex justify-center">
              <v-img max-width="60%" :src="image"></v-img>
            </v-container>
            <v-card-title class="d-flex justify-center title">{{
              t("title")
            }}</v-card-title>
            <v-container>
              <v-form ref="form">
                <v-row dense>
                  <v-col cols="12">
                    <sc-text-field
                      rule-required
                      :label="t('password')"
                      type="password"
                      v-model="password"
                    ></sc-text-field>
                  </v-col>
                  <v-col cols="12">
                    <sc-text-field
                      rule-required
                      :label="t('repeatPassword')"
                      type="password"
                      v-model="passwordConfirm"
                    ></sc-text-field>
                  </v-col>
                  <v-col cols="12" class="my-0 py-0">
                    <v-alert
                      v-show="passwordNotMatch"
                      transition="scale-transition"
                      class="rounded-xl"
                      dense
                      text
                      type="error"
                      >{{ t("passwordNotMatch") }}</v-alert
                    >
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-card-actions class="d-flex justify-center">
              <sc-btn block :loading="loading" @click="confirm">{{ t("title") }}</sc-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    image: require("@/assets/images/shuttle-central-logo.svg"),
    token: null,
    password: null,
    passwordConfirm: null,
    loading: false,
  }),
  computed: {
    passwordNotMatch: (vm) => {
      if (vm.password && !vm.passwordConfirm) return false;
      if (!vm.password && vm.passwordConfirm) return false;
      if (vm.password !== vm.passwordConfirm) return true;
      return false;
    },
  },
  methods: {
    t(key, options = {}) {
      return this.$t(`public.udpatePassword.${key}`, options);
    },
    confirm() {
      if (!this.$refs.form.validate() || this.passwordNotMatch) return;
      this.loading = true;
      this.API.auth
        .updatePassword({ token: this.token, password: this.password })
        .then(() => {
          this.$router.push('/#login');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    init() {
      try {
        const { token, lang } = this.$route.query;
        this.$root.changeLang(lang);
        this.token = token;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
